"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentPadder = exports.HorizontalLine = exports.ColumnSpacer = exports.RowSpacer = exports.ColumnLayoutContainer = exports.RowLayoutContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const RowLayoutContainer = styled_1.default.div `
  display: flex;
  flex-direction: row;
  width: 100%;
  & > div {
    width: 100%;
  }
`;
exports.RowLayoutContainer = RowLayoutContainer;
const ColumnLayoutContainer = styled_1.default.div ``;
exports.ColumnLayoutContainer = ColumnLayoutContainer;
const ColumnSpacer = styled_1.default.span `
  ${(props) => `width: ${typeof props.width == 'string' ? props.width : props.width + 'px'};`}
  display: flex;
  //height: 100%;
  flex-grow: 0;
  flex-shrink: 0;
`;
exports.ColumnSpacer = ColumnSpacer;
const RowSpacer = styled_1.default.div `
  ${(props) => `height: ${typeof props.height == 'string' ? props.height : props.height + 'px'};`}
  display: flex;
  //height: 100%;
  flex-grow: 0;
  flex-shrink: 0;
`;
exports.RowSpacer = RowSpacer;
const HorizontalLine = styled_1.default.div `
  ${(props) => `height: ${props.height}px;`}
  ${(props) => `background-color: ${props.color};`}
`;
exports.HorizontalLine = HorizontalLine;
const ComponentPadder = styled_1.default.div `
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  padding: ${(props) => (props.padding ? props.padding : 0)};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : 0)}px;
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'none')};
  & :nth-child(even) {
    //background: #fdd;
  }
  & :nth-child(odd) {
    //background: #dfd;
  }
`;
exports.ComponentPadder = ComponentPadder;
